import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react'
import type { JSX } from 'react'
import { useContext } from 'react'
import { ConditionsAddressedBlock } from '#src/components/rich-text-editor/ConditionsAddressedBlockNode/ConditionsAddressedBlock.tsx'
import { CompositionContext } from '#src/contexts/CompositionContext.tsx'
import { useEncounterDiagnoses } from '#src/hooks/useEncounterDiagnoses.ts'

export function ConditionsAddressedBlockNodeView({
  editor,
}: NodeViewProps): JSX.Element {
  const compositionReferenceString = useContext(CompositionContext)
  const isEditable = editor.isEditable

  const {
    conditionReferenceStrings,
    isLoading,
    hasEncounter,
    removeCondition,
    reorderConditions,
  } = useEncounterDiagnoses(compositionReferenceString)

  return (
    <NodeViewWrapper>
      <ConditionsAddressedBlock
        conditionReferenceStrings={conditionReferenceStrings}
        isLoading={isLoading}
        hasEncounter={hasEncounter}
        onReorder={isEditable ? reorderConditions : undefined}
        onRemove={isEditable ? removeCondition : undefined}
        isEditable={isEditable}
      />
    </NodeViewWrapper>
  )
}
